export const getSubHeaderValue = (selectedData) => {

    const subHeaderValue = selectedData.map((selectedDataItem) => {

        return selectedDataItem.label;

    }).join(', ');

    return subHeaderValue;

};
